// extracted by mini-css-extract-plugin
export var box = "simple-card-module--box--f742d";
export var hidden = "simple-card-module--hidden--9537e";
export var title = "simple-card-module--title--fa527";